import React, { Component } from "react";

import db from "../../services/query";

class HeaderDate extends Component {
  state = {
    date: [],
  };

  componentDidMount = async () => {
    await db.getAll("calendar/today").then(({ data: { data } }) => {
      this.setState({ date: data[0] });
    });
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    return this.state.date != nextState.date;
  };

  render() {
    const { date } = this.state;

    return (
      <div className="header-date">
        <div className="date-box right-dir ">
          <div className="date-wrapper">
            <div className="day">
              <p>{date?.persian_day}</p>
            </div>
            <div className="month-year">
              <p>{date?.persian_month}</p>
              <p>{date?.persian_year}</p>
            </div>
          </div>
        </div>
        <div className="date-box mr-5">
          <div className="date-wrapper">
            <div className="day">
              <p>{date?.miladi_day}</p>
            </div>
            <div className="month-year">
              <p>{date?.miladi_month}</p>
              <p>{date?.miladi_year}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderDate;
